import request from '@/utils/request'
import URL from './urlTranslator'

// 根据code获取用户维护的港口信息
export function getUserPortByCode(params) {
  return request({
    url: URL.sys.getUserPortByCode,
    method: 'get',
    params
  })
}

// 匹配用户关联港口
export function getMatchedUserPorts(params) {
  return request({
    url: URL.sys.getMatchedUserPorts,
    method: 'get',
    params
  })
}

// 获取关联港口
export function getUserPortByUserIdAndCodeFunc(params) {
  return request({
    url: URL.sys.getUserPortByUserIdAndCodeUrl,
    method: 'get',
    params
  })
}

// 获取用户关联港口之中所有用户
export function getAllUserOfUserPort(params) {
  return request({
    url: URL.sys.getAllUserOfUserPort,
    method: 'get',
    params
  })
}

// 批量删除港口关联
export function batchDeleteUserPortFunc(requestBody) {
  return request({
    url: URL.sys.batchDeleteUserPortUrl,
    method: 'post',
    data: requestBody
  })
}

// 保存港口关联
export function onSaveFunc(data) {
  return request({
    url: URL.sys.onSaveUrl,
    method: 'post',
    data
  })
}
